import React from 'react';
import { Box, InlineLink, Text } from '@fullstory/components';
import { EngagementMapsDetailsRow } from '../EngagementMapsDetailsRow';
import { FormattedMessage, useIntl } from 'react-intl';
import { intl } from '@fullstory/intl';

const PAGE_UNDEFINED_TEXT = intl.formatMessage({
  defaultMessage: 'Page is not defined',
  id: '54XhCA',
});

export interface PagePathRowProps {
  canonicalPagePath: string | null;
  domain: string | null;
}

export const PagePathRow: React.FC<PagePathRowProps> = ({ canonicalPagePath, domain }) => {
  const intl = useIntl();
  return (
    <EngagementMapsDetailsRow
      data-component="PagePathRow"
      icon={{ name: 'omnisearch/page-load' }}
      label={{ body: intl.formatMessage({ defaultMessage: 'Page:', id: 'wyRVcv' }) }}
      value={{ body: canonicalPagePath || PAGE_UNDEFINED_TEXT }}
      tooltipContent={
        canonicalPagePath && domain ? (
          <>
            <Box>
              <Text appearance="bodySmall" color="secondary-inverse">
                <FormattedMessage defaultMessage="Domain: " id="PmDYtq" />
              </Text>
            </Box>
            <Box>
              <Text appearance="bodySmall" color="inherit">
                {domain}
              </Text>
            </Box>
            <Box paddingTop={4}>
              <Text appearance="bodySmall" color="secondary-inverse">
                <FormattedMessage defaultMessage="Path: " id="ZAIvjW" />
              </Text>
            </Box>
            <Box>
              <Text appearance="bodySmall" color="inherit">
                {canonicalPagePath}
              </Text>
            </Box>
            <Box paddingTop={8}>
              <Text appearance="bodySmall" color="inherit">
                <FormattedMessage
                  defaultMessage="Data from any URL that matches this pattern or page layout will be included in these results."
                  id="TSBo5/"
                />
              </Text>
            </Box>
          </>
        ) : (
          <Box paddingTop={8}>
            <Text appearance="bodySmall" color="inherit">
              <FormattedMessage
                defaultMessage="The Pages or URLs in this group haven't been defined. Explore the Pages and URLs that are not defined <link>as a metric</link>."
                id="lKKZlc"
                values={{
                  link: text => (
                    <InlineLink
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://help.fullstory.com/hc/en-us/articles/360052331173-Pages-in-Fullstory#01FE48A345B2W99CHQVWWV0ZJB"
                    >
                      {text}
                    </InlineLink>
                  ),
                }}
              />
            </Text>
          </Box>
        )
      }
    />
  );
};
